import type { ReactNode } from "react";

export function BrowserChrome({
	url,
	children,
}: {
	url: string;
	children: ReactNode;
}) {
	return (
		<div className="border-cv-bdr bg-cv-bg-card overflow-hidden rounded-xl border shadow-[0_0_0_1px_rgba(255,255,255,0.04)_inset,0_48px_120px_rgba(0,0,0,0.6)]">
			<div className="border-cv-bdr bg-cv-bg-elevated flex h-9 items-center gap-2.5 border-b px-3.5">
				<div className="flex gap-1.5">
					<div className="bg-cv-bdr-mid h-2.5 w-2.5 rounded-full" />
					<div className="bg-cv-bdr-mid h-2.5 w-2.5 rounded-full" />
					<div className="bg-cv-bdr-mid h-2.5 w-2.5 rounded-full" />
				</div>
				<div className="flex flex-1 justify-center">
					<div className="border-cv-bdr bg-cv-bg text-cv-fg-muted rounded border px-3 py-0.5 text-[10px]">
						{url}
					</div>
				</div>
			</div>
			{children}
		</div>
	);
}
